var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheme1Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_525",
    "data-name": "Group 525",
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.231,
    height: 72.891,
    viewBox: "0 0 94.231 72.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M945.083,342.768a6.184,6.184,0,0,1-2.573-.545,6.638,6.638,0,0,1-2.117-1.51,7.23,7.23,0,0,1,0-9.895,6.676,6.676,0,0,1,2.117-1.5,6.374,6.374,0,0,1,5.59.211,6.785,6.785,0,0,1,2.284,2.021l-2.584,1.387a3.8,3.8,0,0,0-1.2-.926,3.362,3.362,0,0,0-1.512-.347,3.3,3.3,0,0,0-1.45.318,3.77,3.77,0,0,0-1.2.881,4.13,4.13,0,0,0-.806,1.306,4.365,4.365,0,0,0-.289,1.6,4.309,4.309,0,0,0,.289,1.59,4.131,4.131,0,0,0,.806,1.306,3.826,3.826,0,0,0,1.2.886,3.418,3.418,0,0,0,2.962-.029,3.8,3.8,0,0,0,1.2-.939l2.584,1.408a6.906,6.906,0,0,1-2.284,2.015,6.129,6.129,0,0,1-3.017.761Z",
    transform: "translate(-938.45 -282.645)",
    fill: "#0182f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M992.819,330.69h3.259l4.9,13.5h-3.066l-.772-2.12h-5.379l-.772,2.12H987.92l4.9-13.5Zm0,8.484h3.259l-1.64-4.474Z",
    transform: "translate(-975.022 -284.064)",
    fill: "#0182f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M1043.91,344.2V330.7h5.5a3.711,3.711,0,0,1,2.005.558,4.085,4.085,0,0,1,1.421,1.5,4.174,4.174,0,0,1,.524,2.068,4.427,4.427,0,0,1-.289,1.614,4.042,4.042,0,0,1-.824,1.319,4.177,4.177,0,0,1-1.259.92l3.2,5.514h-3.335l-3.045-5.243h-1v5.243h-2.891Zm2.891-8.137h2.255a1.293,1.293,0,0,0,.7-.2,1.523,1.523,0,0,0,.511-.527,1.449,1.449,0,0,0,0-1.444,1.493,1.493,0,0,0-.511-.524,1.316,1.316,0,0,0-.7-.2H1046.8Z",
    transform: "translate(-1016.414 -284.072)",
    fill: "#0182f0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M1098.332,344.2l-3.452-13.5h2.988l2.083,8.174,2.083-8.174h2.662l2.083,8.174,2.083-8.174h2.988l-3.431,13.5h-3.259l-1.794-7-1.773,7h-3.259Z",
    transform: "translate(-1054.095 -284.072)",
    fill: "#0182f0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M1164.479,330.69h3.259l4.9,13.5h-3.066l-.772-2.12h-5.379l-.772,2.12h-3.066l4.9-13.5Zm0,8.484h3.259l-1.64-4.474Z",
    transform: "translate(-1101.926 -284.064)",
    fill: "#0182f0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M1216.991,342.768a6.571,6.571,0,0,1-2.18-.362,5.533,5.533,0,0,1-1.823-1.04,3.912,3.912,0,0,1-1.129-1.624l2.719-1a1.247,1.247,0,0,0,.43.54,2.786,2.786,0,0,0,.845.43,3.628,3.628,0,0,0,1.137.169,3.471,3.471,0,0,0,1.09-.169,2.193,2.193,0,0,0,.829-.467.926.926,0,0,0,.318-.694.825.825,0,0,0-.334-.67,2.577,2.577,0,0,0-.847-.425,6.88,6.88,0,0,0-1.056-.237,10.839,10.839,0,0,1-2.628-.7,4.434,4.434,0,0,1-1.833-1.345,3.438,3.438,0,0,1-.67-2.18,3.5,3.5,0,0,1,.714-2.214,4.725,4.725,0,0,1,1.885-1.478,6.042,6.042,0,0,1,2.532-.529,6.584,6.584,0,0,1,2.182.362,5.476,5.476,0,0,1,1.828,1.046,3.851,3.851,0,0,1,1.119,1.64l-2.719.983a1.189,1.189,0,0,0-.43-.534,2.779,2.779,0,0,0-.845-.42,3.707,3.707,0,0,0-1.137-.164,3.113,3.113,0,0,0-1.069.164,2.349,2.349,0,0,0-.839.472.9.9,0,0,0-.328.675.953.953,0,0,0,.307.777,1.891,1.891,0,0,0,.814.362c.336.07.709.136,1.113.193a9.687,9.687,0,0,1,2.555.722,4.976,4.976,0,0,1,1.869,1.387,3.246,3.246,0,0,1,.7,2.112,3.633,3.633,0,0,1-.709,2.214,4.71,4.71,0,0,1-1.875,1.478,6.06,6.06,0,0,1-2.545.529Z",
    transform: "translate(-1140.575 -282.645)",
    fill: "#0182f0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M1267.023,330.69h2.891v13.5h-2.891V338.4h-4.782v5.783h-2.891v-13.5h2.891v4.821h4.782Z",
    transform: "translate(-1175.683 -284.064)",
    fill: "#0182f0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M1070.686,390h2.167l3.927,10.8h-2l-.693-1.914h-4.628l-.693,1.914h-2l3.919-10.8Zm-.54,7h3.246l-1.627-4.451Z",
    transform: "translate(-1033.314 -327.911)",
    fill: "#f79420"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M1111.34,400.8V390h3.856a2.966,2.966,0,0,1,1.593.441,3.188,3.188,0,0,1,1.129,1.181,3.384,3.384,0,0,1-.01,3.275,3.311,3.311,0,0,1-1.145,1.173,2.968,2.968,0,0,1-1.564.435h-1.974v4.3h-1.882Zm1.883-6.177H1115a1.394,1.394,0,0,0,.733-.2,1.543,1.543,0,0,0,.529-2.06,1.48,1.48,0,0,0-.529-.54,1.394,1.394,0,0,0-.733-.2h-1.773Z",
    transform: "translate(-1066.263 -327.911)",
    fill: "#f79420"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M1144.74,400.8V390h3.856a2.966,2.966,0,0,1,1.593.441,3.188,3.188,0,0,1,1.129,1.181,3.385,3.385,0,0,1-.01,3.275,3.314,3.314,0,0,1-1.145,1.173,2.968,2.968,0,0,1-1.564.435h-1.974v4.3h-1.882Zm1.88-6.177h1.773a1.394,1.394,0,0,0,.733-.2,1.5,1.5,0,0,0,.529-.54,1.485,1.485,0,0,0,.2-.756,1.514,1.514,0,0,0-.2-.764,1.481,1.481,0,0,0-.529-.54,1.394,1.394,0,0,0-.733-.2h-1.773Z",
    transform: "translate(-1090.955 -327.911)",
    fill: "#f79420"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M1042.657,172.442a3.11,3.11,0,0,1-1.171-2.43,2.714,2.714,0,0,1,2.711-2.712h2.159a2.564,2.564,0,0,1,1.742.683l1.014-1.523a7.346,7.346,0,0,1,6.143-3.264h11.829a7.354,7.354,0,0,1,6.145,3.264l1.012,1.52a2.563,2.563,0,0,1,1.742-.683h2.159a2.715,2.715,0,0,1,2.712,2.712,3.108,3.108,0,0,1-1.168,2.43,7.24,7.24,0,0,1,1.755,2.615,20.671,20.671,0,0,0,.182-2.743,20.451,20.451,0,1,0-40.9,0,20.692,20.692,0,0,0,.182,2.743,7.236,7.236,0,0,1,1.752-2.615Z",
    transform: "translate(-1014.056 -151.86)",
    fill: "#0182f0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M1100.473,293.878c-.039-.026-.078-.052-.117-.081l-1.39-1.04a.771.771,0,0,0-.464-.156h-16.42a.773.773,0,0,0-.456.151l-1.408,1.051c-.034.026-.07.05-.107.073v.224a20.482,20.482,0,0,0,20.36,0v-.227Z",
    transform: "translate(-1043.176 -255.905)",
    fill: "#0182f0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M1061.738,213.194a8,8,0,0,0,2.584.43h13.633a7.925,7.925,0,0,0,2.584-.43l7.543-2.576a6.236,6.236,0,0,0-3.215-1.278l-3.142-4.717a5.6,5.6,0,0,0-4.67-2.474h-11.829a5.6,5.6,0,0,0-4.67,2.474l-3.142,4.717a6.229,6.229,0,0,0-3.215,1.278l7.543,2.576Z",
    transform: "translate(-1024.021 -189.038)",
    fill: "#f79420"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M1082.434,236.59l-7.884,2.693a8.649,8.649,0,0,1-2.8.464h-13.633a8.651,8.651,0,0,1-2.8-.464l-7.884-2.693a6.5,6.5,0,0,0-1.627,4.685v8.734a1.212,1.212,0,0,0,1.212,1.212h6.054a1.213,1.213,0,0,0,.727-.242l1.4-1.045a2.523,2.523,0,0,1,1.523-.508h16.42a2.535,2.535,0,0,1,1.525.508l1.4,1.045a1.2,1.2,0,0,0,.728.242h6.057a1.213,1.213,0,0,0,1.212-1.212v-8.734a6.5,6.5,0,0,0-1.629-4.685Z",
    transform: "translate(-1017.819 -214.499)",
    fill: "#f79420"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M1050.01,297.555a.714.714,0,0,0,.714.714h4.654a.714.714,0,0,0,.714-.714V296.29h-6.08v1.265Z",
    transform: "translate(-1020.923 -258.633)",
    fill: "#27b7ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M1165,297.555a.714.714,0,0,0,.714.714h4.654a.714.714,0,0,0,.714-.714V296.29H1165v1.265Z",
    transform: "translate(-1105.932 -258.633)",
    fill: "#27b7ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M1097.568,174.9l.5,1.348,1.348.5a.054.054,0,0,1,0,.1l-1.348.5-.5,1.348a.054.054,0,0,1-.1,0l-.5-1.348-1.348-.5a.054.054,0,0,1,0-.1l1.348-.5.5-1.348A.054.054,0,0,1,1097.568,174.9Z",
    transform: "translate(-1054.616 -168.867)",
    fill: "#27b7ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M1074.65,211.149l2.138-3.21a4.52,4.52,0,0,1,3.781-2h11.373a4.517,4.517,0,0,1,3.781,2l2.141,3.21Z",
    transform: "translate(-1039.139 -191.84)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M1057.061,251.622l-4.279-.2a.82.82,0,0,1-.782-.819v-1.15a1.163,1.163,0,0,1,1.374-1.145l5.277.965a.513.513,0,0,1,.321.808l-.712.97a1.4,1.4,0,0,1-1.2.571Z",
    transform: "translate(-1022.395 -223.145)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M1059.6,282.652h-2.933a.48.48,0,0,1-.43-.691l.451-.923a.48.48,0,0,1,.43-.269h2.915a.48.48,0,0,1,.435.683l-.433.923A.477.477,0,0,1,1059.6,282.652Z",
    transform: "translate(-1025.492 -247.16)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M1081.208,259.321a.508.508,0,0,1-.521-.615l.362-1.358a3.643,3.643,0,0,1,3.3-2.659c.086-.005.169-.008.255-.008h12.178c.083,0,.172,0,.255.008a3.645,3.645,0,0,1,3.3,2.659l.36,1.358a.506.506,0,0,1-.519.615Z",
    transform: "translate(-1043.591 -227.872)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M1161.107,251.622l4.279-.2a.82.82,0,0,0,.782-.819v-1.15a1.163,1.163,0,0,0-1.374-1.145l-5.277.965a.513.513,0,0,0-.321.808l.712.97a1.4,1.4,0,0,0,1.2.571Z",
    transform: "translate(-1101.568 -223.145)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M1166.349,282.652h2.933a.48.48,0,0,0,.43-.691l-.451-.923a.48.48,0,0,0-.43-.269h-2.915a.48.48,0,0,0-.435.683l.433.923A.477.477,0,0,0,1166.349,282.652Z",
    transform: "translate(-1106.254 -247.16)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M1082.213,227.3l.412,1.111,1.111.412a.044.044,0,0,1,0,.083l-1.111.412-.412,1.111a.044.044,0,0,1-.083,0l-.412-1.111-1.111-.412a.044.044,0,0,1,0-.083l1.111-.412.412-1.111A.044.044,0,0,1,1082.213,227.3Z",
    transform: "translate(-1043.521 -207.607)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M1051.391,217.87h2.159a.806.806,0,0,1,.806.806v1.319a.164.164,0,0,1-.164.164H1051.8a1.35,1.35,0,0,1-1.348-1.348h0A.942.942,0,0,1,1051.391,217.87Z",
    transform: "translate(-1021.249 -200.66)",
    fill: "#f79420"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M1.348,0H3.741a.164.164,0,0,1,.164.164V1.484a.806.806,0,0,1-.806.806H.941A.942.942,0,0,1,0,1.348H0A1.35,1.35,0,0,1,1.348,0Z",
    transform: "translate(65.03 19.5) rotate(180)",
    fill: "#f79420"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M1127.317,163.009l.793,2.143,2.143.793a.086.086,0,0,1,0,.162l-2.143.793-.793,2.143a.086.086,0,0,1-.162,0l-.793-2.143-2.143-.793a.086.086,0,0,1,0-.162l2.143-.793.793-2.143A.086.086,0,0,1,1127.317,163.009Z",
    transform: "translate(-1075.742 -160.06)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M1163.528,182.159l.555,1.5,1.5.555a.062.062,0,0,1,0,.115l-1.5.555-.555,1.5a.062.062,0,0,1-.115,0l-.556-1.5-1.5-.555a.062.062,0,0,1,0-.115l1.5-.555.556-1.5A.062.062,0,0,1,1163.528,182.159Z",
    transform: "translate(-1103.212 -174.23)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme1Logo);
export default __webpack_public_path__ + "static/media/theme1-logo.62cead880b601a0e78a63f9444c8929c.svg";
export { ForwardRef as ReactComponent };